import { Injectable, InjectionToken } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export abstract class IAssetsService {

  public abstract categoryDefaultImageGetAsync(): Promise<string>;

  public abstract productDefaultImageGetAsync(): Promise<string>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAssetsServiceToken = new InjectionToken<IAssetsService>('IAssetsService');
